import React, { Component } from 'react';
import getLocaleMessages from '../../utils/localesMessages';

const {
	header,
	note,
	stayAndFinishButton,
	leaveNowButton
} = getLocaleMessages('buttons/leaveModal');

const {
	close
} = getLocaleMessages('buttons/errors');

export class LeaveModal extends Component {
	render() {
		return (
			<div
				className={"vx_modal-glimpse vx_modalPrepToOpen leave_modal"}
				id="leave-modal"
				role="dialog"
				aria-describedby="leave-modal-header"
				tabIndex="0"
				aria-label="Modal Dialog"
			>
				<div className="vx_modal-content">
					<button
						className="vx_modal-dismiss_x-trigger"
						data-modal-id="_demoVxModal-glimpse"
						id="dismiss-leave"
					>
						<span className="vx_a11yText">{close}</span>
					</button>

					<header className="vx_modal-header" id="leave-modal-header">
						<p>{header}</p>
					</header>

					<div className="vx_modal-body">
						<p>{note}</p>
						<button
							className="vx_btn vx_btn-primary"
							type="submit"
							id="stay-and-finish"
						>
							{stayAndFinishButton}
						</button>
						<button
							className="vx_btn vx_btn-secondary"
							type="submit"
							id="leave-now"
						>
							{leaveNowButton}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default LeaveModal;



// WEBPACK FOOTER //
// ./buttons/components/modals/LeaveModal.js